import { Title } from "@mantine/core";
import { type SiteSetupProcessDataStep } from "../../../types/api.types";
import { getTitleFromStep } from "../utils/getTitleFromStep";

interface StepTitleProps {
  activeStep: SiteSetupProcessDataStep;
  isActive: boolean;
}

function StepTitle({ isActive, activeStep }: StepTitleProps) {
  return (
    <>
      {isActive && (
        <Title
          className="SiteSetupAssistantTitle"
          fw="500"
          mb="xl"
          mt="sm"
          order={3}
          ta="center"
        >
          {getTitleFromStep(activeStep)}
        </Title>
      )}
    </>
  );
}

export { StepTitle };
